import { render, staticRenderFns } from "./FlexItem.vue?vue&type=template&id=458e8b0a&"
import script from "./FlexItem.vue?vue&type=script&lang=js&"
export * from "./FlexItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports